import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import '../styles.css';

export default function ProfilPage() {
  const { user, api, logout, updateUser } = useAuth();
  const navigate = useNavigate();
  const [tab, setTab] = useState('perso');
  const [form, setForm] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (user) setForm({
      nom: user.nom || '', prenom: user.prenom || '',
      mobile: user.mobile || '', email: user.email || '',
      civilite: user.civilite || '',
      mois_naissance: user.mois_naissance || '', annee_naissance: user.annee_naissance || '',
    });
  }, [user]);

  const handleLogout = () => { logout(); navigate('/login'); };

  const handleSave = async () => {
    setSaving(true);
    try {
      const { data } = await api.put(`/users/${user.id}`, form);
      updateUser(data);
      toast.success('Profil mis à jour !');
    } catch { toast.error('Erreur lors de la sauvegarde'); }
    finally { setSaving(false); }
  };

  const initials = `${user?.prenom?.[0]||''}${user?.nom?.[0]||''}`.toUpperCase();

  return (
    <div style={{ minHeight: '100vh' }}>
      <div style={{ padding: '12px 20px 10px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#1c1c1e' }}>Mon profil</h1>
        <button onClick={handleSave} disabled={saving}
          className="mb-btn mb-btn-ghost mb-btn-sm">
          {saving ? 'Enregistrement...' : 'Enregistrer'}
        </button>
      </div>

      <div className="mb-content" style={{ paddingTop: 0 }}>
        {/* Hero */}
        <div className="mb-hero mb-mb-md" style={{ position: 'relative' }}>
          <button onClick={handleLogout} title="Se déconnecter"
            style={{ position: 'absolute', top: 14, right: 14, width: 32, height: 32, borderRadius: '50%', background: 'rgba(239,68,68,0.15)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
          </button>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
            <div style={{ position: 'relative' }}>
              <div className="mb-hero-avatar">
                {user?.photo_url ? <img src={user.photo_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : initials}
              </div>
              <button style={{ position: 'absolute', bottom: 0, right: 0, width: 26, height: 26, borderRadius: '50%', background: 'white', border: '2px solid #3C2618', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="#3C2618" strokeWidth="2.5"><path d="M23 19a2 2 0 01-2 2H3a2 2 0 01-2-2V8a2 2 0 012-2h4l2-3h6l2 3h4a2 2 0 012 2z"/><circle cx="12" cy="13" r="4"/></svg>
              </button>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
              <div className="mb-hero-name">{user?.prenom} {user?.nom}</div>
              <div className="mb-hero-sub">{user?.roles?.includes('super_admin') ? 'Super Administrateur' : user?.roles?.includes('franchise') ? 'Franchisé' : user?.roles?.includes('animateur') ? 'Animateur' : 'Membre'}</div>
              <div style={{ display: 'flex', gap: 6, marginTop: 8, flexWrap: 'wrap' }}>
                <span style={{ display: 'flex', alignItems: 'center', gap: 4, background: 'rgba(255,255,255,0.1)', padding: '4px 8px', borderRadius: 20 }}>
                  <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#95C11F' }} />
                  <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.85)' }}>Membre actif</span>
                </span>
                <span style={{ display: 'flex', alignItems: 'center', gap: 4, background: 'rgba(255,255,255,0.1)', padding: '4px 8px', borderRadius: 20 }}>
                  <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#f59e0b' }} />
                  <span style={{ fontSize: 11, color: 'rgba(255,255,255,0.85)' }}>Fin : 18 avr. 2026</span>
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Onglets */}
        <div style={{ display: 'flex', background: '#e5e5ea', borderRadius: 10, padding: 2, marginBottom: 14 }}>
          {[['perso','Infos perso'],['societe','Ma société'],['reglages','Réglages']].map(([key, label]) => (
            <button key={key} onClick={() => setTab(key)}
              style={{ flex: 1, padding: '6px', borderRadius: 8, border: 'none', fontSize: 12, fontWeight: 600, cursor: 'pointer', background: tab === key ? 'white' : 'transparent', color: tab === key ? '#1c1c1e' : '#8e8e93', boxShadow: tab === key ? '0 1px 3px rgba(0,0,0,0.1)' : 'none' }}>
              {label}
            </button>
          ))}
        </div>

        {/* Infos perso */}
        {tab === 'perso' && (
          <div>
            <div className="mb-card mb-mb-md">
              <div className="mb-card-title">Informations personnelles</div>
              {[
                { label: 'Prénom', key: 'prenom', type: 'text' },
                { label: 'Nom', key: 'nom', type: 'text' },
                { label: 'Mobile', key: 'mobile', type: 'tel' },
                { label: 'Email', key: 'email', type: 'email' },
              ].map(f => (
                <div key={f.key} className="mb-field" style={{ marginBottom: 10 }}>
                  <label className="mb-label">{f.label}</label>
                  <input type={f.type} value={form[f.key]||''} onChange={e => setForm(p => ({ ...p, [f.key]: e.target.value }))} className="mb-input" />
                </div>
              ))}
            </div>

            <div className="mb-card mb-mb-md">
              <div className="mb-card-title">Mon parrain & filleuls</div>
              <div className="mb-info-row">
                <div className="mb-info-ico"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#95C11F" strokeWidth="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg></div>
                <span className="mb-info-label">Parrain</span>
                <span className="mb-info-value">Thomas Moreau</span>
              </div>
              <div className="mb-info-row">
                <div className="mb-info-ico"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#95C11F" strokeWidth="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg></div>
                <span className="mb-info-label">Mes filleuls</span>
                <span className="mb-info-value mb-info-link">3 filleuls →</span>
              </div>
              <div className="mb-info-row">
                <div className="mb-info-ico"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#95C11F" strokeWidth="2"><circle cx="12" cy="8" r="4"/><path d="M20 21a8 8 0 10-16 0"/></svg></div>
                <span className="mb-info-label">Suppléants</span>
                <span className="mb-info-value mb-info-link">2 suppléants →</span>
              </div>
            </div>
          </div>
        )}

        {/* Ma société */}
        {tab === 'societe' && (
          <div>
            <div className="mb-card mb-mb-md">
              <div className="mb-card-title">Ma société</div>
              {[
                { label: 'Société', key: 'societe' },
                { label: 'Métier représenté', key: 'metier_represente' },
                { label: 'Adresse bureau', key: 'adresse_bureau' },
                { label: 'Site web', key: 'site_web', type: 'url' },
              ].map(f => (
                <div key={f.key} className="mb-field" style={{ marginBottom: 10 }}>
                  <label className="mb-label">{f.label}</label>
                  <input type={f.type||'text'} value={form[f.key]||''} onChange={e => setForm(p => ({ ...p, [f.key]: e.target.value }))} className="mb-input" />
                </div>
              ))}
            </div>
            <div className="mb-card mb-mb-md">
              <div className="mb-card-title" style={{ display: 'flex', justifyContent: 'space-between' }}>
                Présentation <span style={{ fontSize: 12, color: '#8e8e93', fontWeight: 400 }}>300 car. max</span>
              </div>
              <textarea value={form.description||''} onChange={e => setForm(p => ({ ...p, description: e.target.value }))} maxLength={300}
                className="mb-input" style={{ minHeight: 100, resize: 'none', lineHeight: 1.6 }}
                placeholder="Décrivez votre activité en quelques mots..." />
            </div>
            <div className="mb-card mb-mb-md">
              <div className="mb-card-title">Réseaux sociaux</div>
              {[
                { label: 'Facebook', key: 'lien_facebook', placeholder: 'https://facebook.com/...' },
                { label: 'LinkedIn', key: 'lien_linkedin', placeholder: 'https://linkedin.com/in/...' },
                { label: 'Instagram', key: 'lien_instagram', placeholder: 'https://instagram.com/...' },
              ].map(f => (
                <div key={f.key} className="mb-field" style={{ marginBottom: 10 }}>
                  <label className="mb-label">{f.label}</label>
                  <input type="url" value={form[f.key]||''} onChange={e => setForm(p => ({ ...p, [f.key]: e.target.value }))} className="mb-input" placeholder={f.placeholder} />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Réglages */}
        {tab === 'reglages' && (
          <div>
            <div className="mb-card mb-mb-md" style={{ padding: 0, overflow: 'hidden' }}>
              {[
                { label: 'Changer le mot de passe', icon: '🔒', bg: '#f0f8e1', action: () => navigate('/changer-mot-de-passe') },
                { label: 'Notifications', icon: '🔔', bg: '#e8f4fb', value: 'Activées' },
                { label: 'Mon groupe', icon: '◎', bg: '#f5ede8', value: 'Groupe Lille' },
                { label: 'FAQ', icon: '?', bg: '#f2f2f7' },
                { label: "Contacter l'animateur", icon: '✉', bg: '#f2f2f7' },
              ].map((item, i) => (
                <div key={i} onClick={item.action}
                  style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 14, borderBottom: i < 4 ? '0.5px solid #f2f2f7' : 'none', cursor: item.action ? 'pointer' : 'default' }}>
                  <div style={{ width: 32, height: 32, borderRadius: 9, background: item.bg, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14 }}>{item.icon}</div>
                  <span style={{ flex: 1, fontSize: 14, fontWeight: 500, color: '#1c1c1e' }}>{item.label}</span>
                  {item.value && <span style={{ fontSize: 13, color: '#8e8e93' }}>{item.value}</span>}
                  <svg width="8" height="14" viewBox="0 0 8 14" fill="none" stroke="#c7c7cc" strokeWidth="2"><path d="M1 1l6 6-6 6"/></svg>
                </div>
              ))}
            </div>
            <button onClick={handleLogout} style={{ width: '100%', padding: 14, borderRadius: 14, background: 'white', border: 'none', fontSize: 15, fontWeight: 600, color: '#ef4444', cursor: 'pointer', boxShadow: '0 1px 3px rgba(0,0,0,0.06)' }}>
              Se déconnecter
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
